import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { register, recoverSession, setLanguage } from '../actions'
import { isAuthenticated, canRecover } from '../services/sessionService'
import { callApi } from '../services/fetchService'
import { showAbout } from '../services/miscService'

import FaIcon from '../components/FaIcon'

import { Layout, Form, Input, Button, message, Divider, Select, Spin, Dropdown, Menu } from 'antd';
const FormItem = Form.Item;
const { Content, Footer } = Layout;
const Option = Select.Option



/**
 * Register view
 */

class Register extends Component {

    static propTypes = {
        session: PropTypes.object,
        register: PropTypes.func.isRequired,
        recoverSession: PropTypes.func.isRequired,
        setLanguage: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        comboboxes: {},
        loading: false,
    }

    confirmDirty = false

    componentWillMount() {
        const { session } = this.props
        if (!isAuthenticated(session)) {
            if (canRecover(session)) {
                if (!session.isRecovering) {
                    this.props.recoverSession()
                }
            }
        }
        this.loadComboboxes()
    }

    loadComboboxes = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'settings'
        }).then((data) => {
            this.setState({
                comboboxes: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    handleConfirmBlur = (e) => {
        this.confirmDirty = this.confirmDirty || !!e.target.value
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form
        if (value && this.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true })
        }
        callback();
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback(this.props.intl.formatMessage({ id: 'register.passwordDoNotMatch' }))
        } else {
            callback();
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.register(values).then((response) => {
                    if (response.error) {
                        const intl = this.props.intl
                        if (response.error.status === 429) {
                            message.warn(intl.formatMessage({ id: 'misc.tooManyRequests' }))
                        } else {
                            switch (response.error.code) {
                                case 6: message.warning(intl.formatMessage({ id: 'register.emailAlreadyUsed' })); break;
                                default: message.error(intl.formatMessage({ id: 'misc.unknownError' })); break;
                            }
                        }
                    } else {
                        this.props.history.push({ pathname: '/message', state: { name: 'almostDone' } })
                    }
                })
            }
        })
    }

    handleLanguageChange = (e) => this.props.setLanguage(e.key)

    render() {
        const { session, location, intl } = this.props
        const { getFieldDecorator } = this.props.form
        const { comboboxes, loading } = this.state

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }

        if (isAuthenticated(session)) {
            if (location.state && location.state.from) {
                return (<Redirect to={location.state.from} />);
            }
            return (<Redirect to={{ pathname: "/" }} />);
        }
        if (loading) {
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }

        return (
            <Layout style={{ minHeight: '100vh', background: '#fff' }}>

                <Dropdown overlay={<Menu onClick={this.handleLanguageChange}>{comboboxes.language.map((option) => <Menu.Item key={option.key}>{option.value}</Menu.Item>)}</Menu>}>
                    <FaIcon icon="language" size="2x" style={{ position: 'absolute', right: 10, top: 5 }} />
                </Dropdown>

                <Content style={{ margin: '16px' }}>
                    <Form layout="horizontal" onSubmit={this.handleSubmit} className="register-form">
                        <h1><FormattedMessage id="register.title" /></h1>
                        <FormItem label={<FormattedMessage id="register.firstName" />} {...formItemLayout}>
                            {getFieldDecorator('firstName', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.firstNameRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.lastName" />} {...formItemLayout}>
                            {getFieldDecorator('lastName', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.lastNameRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <Divider />
                        <FormItem label={<FormattedMessage id="register.addressStreet" />} {...formItemLayout}>
                            {getFieldDecorator('addressStreet', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.addressStreetRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.addressNumber" />} {...formItemLayout}>
                            {getFieldDecorator('addressNumber', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.addressNumberRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.addressZip" />} {...formItemLayout}>
                            {getFieldDecorator('addressZip', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.addressZipRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.addressCity" />} {...formItemLayout}>
                            {getFieldDecorator('addressCity', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.addressCityRequired' }) }]
                            })(<Input />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.addressCountry" />} {...formItemLayout}>
                            {getFieldDecorator('addressCountry', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.addressCountryRequired' }) }]
                            })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {comboboxes.country.map((option) => <Option key={option.key}>{option.value}</Option>)}
                            </Select>)}
                        </FormItem>
                        <Divider />
                        <FormItem label={<FormattedMessage id="register.mobile" />} {...formItemLayout}>
                            {getFieldDecorator('mobile', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.mobileRequired' }) }]
                            })(<Input addonBefore={<FaIcon icon="mobile" fixedWidth />} />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.phone" />} {...formItemLayout}>
                            {getFieldDecorator('phone', {
                            })(<Input addonBefore={<FaIcon icon="phone" fixedWidth />} />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.fax" />} {...formItemLayout}>
                            {getFieldDecorator('fax', {
                            })(<Input addonBefore={<FaIcon icon="fax" fixedWidth />} />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.email" />} {...formItemLayout}>
                            {getFieldDecorator('email', {
                                rules: [
                                    { type: 'email', message: intl.formatMessage({ id: 'register.wrongEmail' }) },
                                    { required: true, message: intl.formatMessage({ id: 'register.emailRequired' }) }
                                ]
                            })(<Input addonBefore={<FaIcon icon="envelope" fixedWidth />} />)}
                        </FormItem>
                        <Divider />
                        <FormItem label={<FormattedMessage id="register.language" />} {...formItemLayout}>
                            {getFieldDecorator('language', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'register.languageRequired' }) }]
                            })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {comboboxes.language.map((option) => <Option key={option.key}>{option.value}</Option>)}
                            </Select>)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.password" />} {...formItemLayout}>
                            {getFieldDecorator('password', {
                                rules: [
                                    { required: true, message: intl.formatMessage({ id: 'register.passwordRequired' }) },
                                    { validator: this.checkConfirm }
                                ]
                            })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                        </FormItem>
                        <FormItem label={<FormattedMessage id="register.confirmPassword" />} {...formItemLayout}>
                            {getFieldDecorator('confirmPassword', {
                                rules: [
                                    { required: true, message: intl.formatMessage({ id: 'register.confirmPasswordRequired' }) },
                                    { validator: this.checkPassword }
                                ]
                            })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} onBlur={this.handleConfirmBlur} type="password" />)}
                        </FormItem>
                        <Divider />
                        <FormItem style={{ textAlign: "right" }}>
                            <Button type="primary" htmlType="submit"><FormattedMessage id="register.registerButton" /></Button>
                            <br /><FormattedMessage id="register.or" /> <Link to="/login"><FormattedMessage id="register.login" /></Link>
                        </FormItem>
                    </Form>
                </Content>

                <Footer style={{ textAlign: 'center', background: '#f8f8f8' }}>
                    &copy; 2020 - <FormattedMessage id="footer.createdBy" /> <a href="https://www.neoxis.be"><FaIcon icon="code" /> Neoxis</a>
                    <div style={{ float: "right" }}><FaIcon icon="info-circle" style={{ cursor: "pointer" }} onClick={() => showAbout(intl)} /></div>
                </Footer>

            </Layout>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    register,
    recoverSession,
    setLanguage
})(Form.create()(Register))))


// WEBPACK FOOTER //
// ./src/containers/Register.js